import React from 'react';
import cn from 'classnames';

import { getPrettyNumber } from '../../helpers/formatting';
import { LINKS_TO_CHECK_TABS, getOldestWaitingLabel } from '../../helpers/links_to_check_helpers';
import { useLinksToCheckContext } from './LinksToCheckContext';

import './LinksToCheckTabs.scss';

const HELD_ORDER = 'Listings that sell fast first, then priority links, then oldest';
const LIKELY_WRONG_SCOPE = ['Things we did on our own that are probably wrong', 'Most likely harm first: how often links like it are wrong × the creators who shared it'];

/** The five question tabs with their waiting counts, and the line saying what this tab holds. */
const LinksToCheckTabs = () => {
  const { question, setQuestion, counts, site, setSite } = useLinksToCheckContext();
  const oldestLabel = getOldestWaitingLabel(counts[question]?.oldestWaitingSince);
  const scope = question === 'likely_wrong' ? LIKELY_WRONG_SCOPE : [oldestLabel, HELD_ORDER].filter(Boolean);

  return (
    <nav className='links-to-check-tabs'>
      <div className='ltc-tabs' role='tablist' aria-label='Links to check'>
        {LINKS_TO_CHECK_TABS.map(tab => (
          <button
            key={tab.question}
            type='button'
            role='tab'
            aria-selected={question === tab.question}
            className={cn('ltc-tab', { active: question === tab.question })}
            onClick={() => setQuestion(tab.question)}
          >
            {tab.label}
            {counts[tab.question] && <span className='ltc-tab-count'>{getPrettyNumber(counts[tab.question].waiting)}</span>}
          </button>
        ))}
      </div>
      <div className='ltc-scope'>
        {scope.map(text => (
          <span key={text}>{text}</span>
        ))}
        {site && (
          <button type='button' className='ltc-site-chip' aria-label={`Show every site, not only ${site}`} onClick={() => setSite('')}>
            Only {site} ✕
          </button>
        )}
      </div>
    </nav>
  );
};

export default LinksToCheckTabs;
